import * as sidebarItems from "../config/sidebar/developer-sidebar.json";

class DeveloperUtil {
    static getSidebarItems() {
        return sidebarItems.default;
    }
}

export default DeveloperUtil;
